import { AddInsightToCollectionsButton, CreateInsightDataFn, Proposition } from '@ecosystem/newron-client-collections';
import { FC } from 'react';
import { CollectionInsightType } from '@components/collections/Model';
import { getCollectionsAmplitudeTrackingTags } from '@utils/collectionUtils/CollectionUtils';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { CategoryLeaderboardDoubleBarChartInsight } from '@components/collections/category-leaderboard-double-bar-chart/Model';
import classnames from 'classnames';
import * as styles from './CategoryLeaderboardCollectionButton.module.scss';

export interface CategoryLeaderboardCollectionButtonProps {
  isTableView: boolean;
  isDisabled: boolean;
  createInsightDataFn: CreateInsightDataFn<CategoryLeaderboardDoubleBarChartInsight>;
}

const CategoryLeaderboardCollectionButton: FC<CategoryLeaderboardCollectionButtonProps> = ({
  isTableView,
  isDisabled,
  createInsightDataFn,
}) => {
  const pagesConfig = usePageConfig();

  if (isTableView) {
    return null;
  }

  return (
    <div
      className={classnames([
        {
          [styles.CategoryLeaderboardCollectionButton]: !isDisabled,
          [styles.CategoryLeaderboardCollectionButtonDisabled]: isDisabled,
        },
      ])}
    >
      <AddInsightToCollectionsButton<CategoryLeaderboardDoubleBarChartInsight>
        type={CollectionInsightType.CategoryLeaderboardBarChart}
        proposition={Proposition.Retail}
        createInsightDataFn={createInsightDataFn}
        selectDataType={true}
        defaultDataType={'live'}
        getTrackingTags={getCollectionsAmplitudeTrackingTags(pagesConfig)}
      />
    </div>
  );
};

export default CategoryLeaderboardCollectionButton;
